<template>
    <div class="Selected folder">

        <span class="text">Folder:</span>

        
            <select class="select" v-model="selected" @change="onChange($event)" v-if="folders">               
                <option v-for="folder in folders" v-bind:value="folder" v-bind:key="folder.rowKey" >
                    {{ folder.name }}
                </option>
            </select>   
        
            <button class="button is-success"                                 
                id="createFolder" v-on:click="createFolderClick">Create new folder</button>
        
       
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: "SelectedFolder",
    async created () {
        if(!this.$store.state.accessToken){
            this.$router.push('login');
            return;            
        }
       
        await this.loadFolders();
    },
    data() {
        return {
            selected: null,            
        }
    },
    methods: {     
        ...mapActions(['getFoldersAction', 'selectFolderAction']),         
        async loadFolders() {
            await this.getFoldersAction();
        }, 
        async selectFolder(folder){
            await this.selectFolderAction(folder);                        
        },
        async createFolderClick(){
            this.$router.push('folder');
        },     
        async onChange() {
            await this.selectFolderAction(this.$data.selected);
        }   
    },
    computed: {
        ...mapState(['selectedFolder','folders']),        
    },   
    watch: {
            'selectedFolder' :{
                immediate: true,
                handler(newValue,oldValue) { 
                    if((newValue != oldValue) && newValue != this.$data.selected )
                    {
                        this.$data.selected = newValue;
                    }
                }
            }
        } 
}
</script>